import { OktaAuth } from "@okta/okta-auth-js";

const issuer = process.env.REACT_APP_OKTA_ISSUER ?? "";
const clientId = process.env.REACT_APP_OKTA_CLIENT_ID ?? "";
const redirectUri = (process.env.REACT_APP_HOST_URL ?? window.location.origin) + "/login/callback";


const oktaConfig = {
  issuer,
  clientId,
  redirectUri,
  scopes: ["openid", "profile", "email", "groups"],
  pkce: true,
  disableHttpsCheck: process.env.NODE_ENV === "development",
  tokenManager: {
    storage: "localStorage",
    autoRenew: true,
    expireEarlySeconds: 30,
    secure: process.env.NODE_ENV === "production"
  }
};

export const oktaAuth = new OktaAuth(oktaConfig);

// Essential error logging only
oktaAuth.tokenManager.on("error", (error) => {
  console.error("Authentication error:", error.message || error);
});

export default oktaConfig;